import React, { useState, useEffect } from "react";
import './HomeAcacia.scss'
import { useTranslation } from "react-i18next";

const HomeAcacia = () => {
  const [showStiky, setShowStiky] = useState('ocultar');
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
    return ( 
        <div id="amenmapa" className='contenedor_home_acacia_desc'>
            <img className='contenedor_home_acacia_fondo' src="/assets/img-velasur-privada-acacia.jpg" alt="" />
                                <div className='contenedor_home_acacia__slider_card_logo'>
                                <div className="contenedor-home-principal">
                                    <img src="/assets/Logos/svg-logo-acacia.svg" alt="Logo Acacia" />
                                    <br></br><br></br>
                                   {/* <p className="textacacia">¡GRACIAS POR TU INTERÉS!</p>
                                    <p className="textacacia1">Todos los terrenos en Privada Acacia han sido vendidos.</p>
                                    <br></br>
                                    <p className="textacacia2">Los terrenos en Privada Acacia se vendieron por completo.</p>
                                    <p className="textacacia2">Ahora puedes ser parte de la segunda etapa antes de que se agoten nuevamente</p><br></br>
                                    <div className='button_dispo_acacia_whats paddingwhats'>
                                        <a href='https://api.whatsapp.com/send?phone=524428801675&text'>¡Respuesta inmediata por Whatsapp!</a>
                                </div>*/}
                                <div className='button_dispo_acacia'>
              <a href='https://disponibilidad.velasur.mx/privada-acacia'>
                {t('buttons.seeAvailability')}
              </a>
            </div>
                                
                                </div>
                            </div>
                           {/* <div className="bottom-info-home">
                            <div className='icon-scroll'></div>
                                <div className='whatsapp'>
                                    <div className={showStiky}>
                                        <a target={'_blank'} href="https://api.whatsapp.com/send?phone=524428801675&text"><img src="/assets/Logos/svg-icon-whatsapp.svg" alt="Whatsapp" /></a>
                                </div>
                                </div>
                                <div className='texto_acacia'>
                                    <p>LOTES RESIDENCIALES PREMIUM</p>
                                </div>
                                </div>*/}
                                <a
        id="ws_script"
        href="https://api.whatsapp.com/send?phone=524428801675&text"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://multipagos.velasresorts.com/images/WhatsApp_Logo_1.png"
          width="65"
          height="65"
          alt="WhatsApp"
        />
      </a>
                                
        </div>
     );
}
export default HomeAcacia;